module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Venues-4881907f82c2252028c973bf81083ce6.png";